import { memo, useEffect, useState } from "react";
import "./App.scss";
import "./style.module.scss";
import DefaultLayout from "@components/layout";
import { useTheme } from "@utils/hooks/useTheme";
import { ConfigProvider } from "antd";

function App() {
  const theme = useTheme();

  return (
    <div
      id="app-layout"
      style={{
        position: "relative",
        overflowX: "hidden",
        minHeight: "100vh",
        backgroundColor: "#f5f5f5",
      }}
    >
      <ConfigProvider
        theme={{
          token: {
            colorPrimary: "#00b840", // normal state
            colorPrimaryHover: "#11d756", // hover state
          },

          // set Input to 50 height
          components: {
            Input: {
              controlHeight: 45,
              controlHeightLG: 45,
              controlHeightSM: 45,
            },
          },
        }}
      >
        <DefaultLayout />
      </ConfigProvider>
    </div>
  );
}

export default memo(App);
